import React from 'react';
import { RouteObject } from 'react-router-dom';
import Products from '../pages/Home/Products';
import ProductDetails from '../pages/Home/Products/ProductDetails';
import GLTFImageDetails from '../pages/Home/Products/GLTFImageDetails';
import AuthPage from '../pages/Auth';
import ProtectedRoute from '../components/ProtectedRoute';
import PublicRoute from '../components/PublicRoute';
import Orders from '../pages/Home/orders';
import SharePage from '../pages/Home/SharePage';
import Cart from '../pages/cart/cart';
import NotFound from '../pages/NotFound';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ARView from '../pages/ARView';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <PublicRoute>
        <AuthPage />
      </PublicRoute>
    ),
  },
  {
    path: '/verify-email',
    element: <AuthPage />,
  },
  {
    path: '/reset-password',
    element: <AuthPage />,
  },
  {
    path: '/signup',
    element: (
      <PublicRoute>
        <AuthPage view="REGISTER" />
      </PublicRoute>
    ),
  },
  {
    path: '/forgotpassword',
    element: (
      <PublicRoute>
        <AuthPage view="FORGOT_PASSWORD" />
      </PublicRoute>
    ),
  },
  {
    path: '/products',
    element: (
      <ProtectedRoute>
        <Products />
      </ProtectedRoute>
    ),
  },
  {
    path: '/products/:id',
    element: (
      <ProtectedRoute>
        <ProductDetails />
      </ProtectedRoute>
    ),
  },
  {
    path: '/products/product-detail/:id',
    element: (
      <ProtectedRoute>
        <GLTFImageDetails />
       </ProtectedRoute>
    ),
  },
  {
    path: '/ar_view/:id',
    element: (
      <>
        <ARView />
      </>
    ),
  },
  {
    path: '/project/:id',
    
    element: (
        <SharePage />
    ),
  },
  {
    path: '/cart',
    element: (
      <ProtectedRoute>
        <Cart />
      </ProtectedRoute>
    ),
  },
  {
    path: '/orders',
    element: (
      <ProtectedRoute>
        <Orders />
      </ProtectedRoute>
    ),
  },
  // {
  //   path: '/:category',
  //   element: (
  //     <ProtectedRoute>
  //       <Home />
  //     </ProtectedRoute>
  //   ),
  // },
  {
    path: '*',
    element: <NotFound />
  }
];

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        {routes.map((route, index) => (
          <Route 
            key={index}
            path={route.path} 
            element={route.element}
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes; 